import { NgModule } from '@angular/core';
import { getSaver, SAVER } from './api-saver.provider';

@NgModule({
    providers: [
        { provide: SAVER, useFactory: getSaver }
    ],
})
export class ApiModule { }
